<template>
  <FormularioCadastro
    module-name="Produto no Fornecedor (Relação Produto-Fornecedor)"
    :is-loading="isSaving || carregandoProduto"
    :is-editing="isEditing"
    :entity-info="entityInfo"
    @submit="salvarRelacao"
    @cancelar="handleCancel"
    @show-notification="(p) => emit('show-notification', p)"
  >
    <template #acoes-header v-if="isEditing">
      <button
        type="button"
        class="btn-icon-minimalista me-3"
        @click="mostrarAuditoria = true"
        title="Ver Histórico de Alterações"
      >
        <i class="bi bi-clock-history"></i>
      </button>
    </template>

    <div class="card mb-3">
      <div class="card-header">
        <h5 class="mb-0"><i class="bi bi-card-text me-2"></i>Dados Básicos</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <CampoBusca
              id="idProduto"
              label="Produto Master"
              v-model="item.idProduto"
              :configuracao-busca="produtoSearch"
              @selecionado="onProdutoSelecionado"
              :disabled="isEditing"
              required
            />
          </div>
          <div class="col-md-6">
            <CampoBusca
              id="idFornecedor"
              label="Fornecedor"
              v-model="item.idFornecedor"
              :configuracao-busca="fornecedorSearch"
              @selecionado="onFornecedorSelecionado"
              :disabled="isEditing"
              required
            />
          </div>
          <div class="col-md-6">
            <CampoInput
              id="codigoNoFornecedor"
              label="Part Number (Código no Fornecedor)"
              v-model="item.codigoNoFornecedor"
              placeholder="Ex: P-9082-A"
              maxlength="100"
            />
          </div>
          <div class="col-md-6">
            <CampoBuscaLista
              id="lstModalidadeRateio"
              label="Modalidade de Rateio de Custos"
              v-model="item.lstModalidadeRateio"
              tabela="ProdutoFornecedor"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">
        <h5 class="mb-0"><i class="bi bi-calculator me-2"></i>Equação de Compra e Conversão</h5>
      </div>
      <div class="card-body">
        <div class="alert alert-info border-0 shadow-sm small py-2 mb-4">
          <i class="bi bi-info-circle-fill me-2"></i>
          Determine como a unidade de compra deste fornecedor converte para o seu estoque. Se o fornecedor vende em Toneladas (TON) e o seu estoque é KG: <strong>[ 1 ] [ TON ] = [ 1000 ] [ KG ]</strong>.
        </div>

        <div class="row g-3">
          <div class="col-md-3">
            <CampoInput id="qtdCompra" label="Qtd. Comprada" type="number" min="0.001" step="any" v-model.number="item.qtdUnidadeFornecedor" required />
          </div>
          <div class="col-md-3">
            <CampoBuscaLista
              id="lstUnidadeFornecedor"
              label="[Unidade do Fornecedor]"
              v-model="item.lstUnidadeFornecedor"
              tabela="ProdutoFornecedor"
              required
            />
          </div>

          <div class="col-md-1 text-center d-flex align-items-center justify-content-center">
            <i class="bi bi-arrow-right fs-4 text-secondary"></i>
          </div>

          <div class="col-md-2">
            <CampoInput id="qtdBaseCompra" label="Qtd. no Estoque" type="number" min="0.001" step="any" v-model.number="item.qtdUnidadeBase" required />
          </div>
          <div class="col-md-3">
            <CampoBuscaLista
              id="lstUnidadeMedidaBase"
              label="[Unidade Base do Produto]"
              v-model="idUnidadeBaseAtiva"
              tabela="Produto"
              disabled
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Frame: Cláusulas do Produto -->
    <div class="card mb-3">
      <div class="card-header bg-info-subtle py-2 cursor-pointer d-flex justify-content-between align-items-center"
           @click="accordionState.clausulasProduto = !accordionState.clausulasProduto">
        <h6 class="mb-0 text-info-emphasis fw-bold">
          <i class="bi bi-file-text me-2"></i>Cláusulas do Produto
          <span v-if="clausulasProduto.length" class="badge bg-info ms-2">{{ clausulasProduto.length }}</span>
        </h6>
        <i class="bi fs-5" :class="accordionState.clausulasProduto ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </div>
      <div class="card-body" v-show="accordionState.clausulasProduto">
        <fieldset :disabled="!isEditing">
          <!-- Botões ACIMA do grid -->
          <div class="d-flex gap-2 mb-2">
            <button class="btn btn-sm btn-outline-info" @click="abrirModalClausulaProduto()">
              <i class="bi bi-plus-circle"></i> Nova Cláusula
            </button>
          </div>

          <div class="admin-table-container border-0 shadow-none mb-0">
            <table class="table admin-table m-0">
              <thead>
                <tr>
                  <th style="width: 60px;">Ordem</th>
                  <th style="width: 200px;">Título</th>
                  <th style="width: 80px;">Definitiva</th>
                  <th style="width: 60px;">Fixa</th>
                  <th style="width: 100px;">Aplicação</th>
                  <th style="width: 100px;">Visibilidade</th>
                  <th style="width: 80px;">Status</th>
                  <th class="text-end" style="width: 120px;">
                    <button type="button" class="btn btn-sm btn-primary py-0" @click.stop="abrirModalClausulaProduto" :disabled="!item.idProdutoFornecedor">
                      <i class="bi bi-plus-lg"></i>
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(cl, idx) in clausulasProduto" :key="cl.idProdutoFornecedorClausula || idx">
                  <td class="text-center">{{ cl.ordemExibicao }}</td>
                  <td class="fw-bold">{{ cl.titulo }}</td>
                  <td class="text-center">
                    <i :class="cl.isDefinitiva ? 'bi bi-check-circle-fill text-success' : 'bi bi-x-circle-fill text-secondary'"></i>
                  </td>
                  <td class="text-center">
                    <i :class="cl.isFixa ? 'bi bi-check-circle-fill text-success' : 'bi bi-x-circle-fill text-secondary'"></i>
                  </td>
                  <td>{{ getTextoListaClausula(cl.lstAplicacaoClausula, listas.LstAplicacaoClausula) }}</td>
                  <td>{{ getTextoListaClausula(cl.lstVisibilidade, listas.LstVisibilidade) }}</td>
                  <td>
                    <span class="badge" :class="cl.lstStatusClausula === 'ST1' ? 'bg-success' : 'bg-secondary'">
                      {{ cl.lstStatusClausula === 'ST1' ? 'Ativo' : 'Inativo' }}
                    </span>
                  </td>
                  <td class="acoes-cell text-end pe-3">
                    <button type="button" class="btn-icon" @click="editarClausulaProduto(cl)" title="Editar">
                      <i class="bi bi-pencil-fill"></i>
                    </button>
                    <button type="button" class="btn-icon" :class="cl.lstStatusClausula === 'ST1' ? 'text-warning' : 'text-success'" @click="toggleStatusClausulaProduto(cl)" :title="cl.lstStatusClausula === 'ST1' ? 'Inativar' : 'Reativar'">
                      <i class="bi" :class="cl.lstStatusClausula === 'ST1' ? 'bi-pause-circle' : 'bi-play-circle'"></i>
                    </button>
                    <button type="button" class="btn-icon text-danger" @click="excluirClausulaProduto(cl)" title="Excluir">
                      <i class="bi bi-trash-fill"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="clausulasProduto.length === 0">
                  <td colspan="8" class="text-center py-4 text-muted">Nenhuma cláusula cadastrada para este produto.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </fieldset>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">
        <h5 class="mb-0"><i class="bi bi-briefcase me-2"></i>Regras Comerciais</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-4">
            <CampoInput
              id="leadTime"
              label="Lead Time (Dias)"
              type="number"
              min="0"
              v-model.number="item.tempoFornecimento"
              placeholder="Produção + Trânsito"
            />
          </div>
          <div class="col-md-4">
            <CampoInput
              id="moq"
              label="Lote Mínimo (MOQ)"
              type="number"
              min="0"
              step="any"
              v-model.number="item.quantidadeMinima"
              placeholder="Ex: 100"
            />
          </div>
          <div class="col-md-4">
            <CampoSelect
              id="moedaForn"
              label="Moeda de Negociação"
              v-model="item.lstMoedaPadrao"
              :options="listas.LstMoedaPadrao || []"
              option-value="idListaClienteItem"
              option-label="textoLista"
            />
          </div>
        </div>
      </div>
    </div>
  </FormularioCadastro>

  <AuditLogViewer
    v-if="mostrarAuditoria"
    tabela="ProdutoFornecedor"
    :chave-primaria="item.idProdutoFornecedor"
    :titulo-registro="displayProduto + ' -> ' + displayFornecedor"
    :tabelas-filhas="['ProdutoFornecedorClausula']"
    chave-estrangeira="IdProdutoFornecedor"
    :dicionarios="{
      'lstUnidadeFornecedor': listas.LstUnidadeFornecedor,
      'lstMoedaPadrao': listas.LstMoedaPadrao,
      'lstModalidadeRateio': listas.LstModalidadeRateio,
      'lstUnidadeMedidaBase': listas.LstUnidadeMedidaBase,
      'LstAplicacaoClausula': listas.LstAplicacaoClausula || [],
      'LstVisibilidade': listas.LstVisibilidade || []
    }"
    @fechar="mostrarAuditoria = false"
  />

  <ModalFormularioV2
    v-model="mostrarModalClausulaProduto"
    :titulo="clausulaProdutoEditando ? 'Editar Cláusula do Produto' : 'Nova Cláusula do Produto'"
    :loading="isSavingClausulaProduto"
    tamanho="lg"
    @confirmar="salvarClausulaProduto"
  >
    <div class="row g-3">
      <div class="col-md-8">
        <CampoInput id="titulo" label="Título" v-model="formClausulaProduto.titulo" required maxlength="200" />
      </div>
      <div class="col-md-4">
        <CampoInput id="ordemExibicao" label="Ordem de Exibição" v-model="formClausulaProduto.ordemExibicao" type="decimal" />
      </div>
      <div class="col-12">
        <CampoInput id="texto" label="Texto da Cláusula" type="textarea" v-model="formClausulaProduto.texto" required />
      </div>
      <div class="col-md-4">
        <CampoSelect id="isDefinitiva" label="Cláusula Definitiva?"
          v-model="formClausulaProduto.isDefinitiva"
          :options="simNaoOptions"
          option-value="id"
          option-label="label" />
      </div>
      <div class="col-md-4">
        <CampoSelect id="isFixa" label="Cláusula Fixa?"
          v-model="formClausulaProduto.isFixa"
          :options="simNaoOptions"
          option-value="id"
          option-label="label" />
      </div>
      <div class="col-md-4">
        <CampoBuscaLista
          id="lstAplicacaoClausula"
          label="Aplicação (Módulo)"
          v-model="formClausulaProduto.lstAplicacaoClausula"
          tabela="ProdutoFornecedorClausula"
          placeholder="Selecione a aplicação..." />
      </div>
      <div class="col-md-4">
        <CampoBuscaLista
          id="lstVisibilidade"
          label="Visibilidade"
          v-model="formClausulaProduto.lstVisibilidade"
          tabela="ProdutoFornecedorClausula"
          placeholder="Selecione a visibilidade..." />
      </div>
      <div class="col-md-4">
        <CampoSelect
          id="lstStatusClausula"
          label="Status"
          v-model="formClausulaProduto.lstStatusClausula"
          :options="listas.statusClausula || []"
          option-value="idListaClienteItem"
          option-label="textoLista"
          required />
      </div>
    </div>
  </ModalFormularioV2>
</template>

<script setup>
import { ref, reactive, onMounted, computed, watch } from 'vue'
import { useFormulario } from '@/composables/useFormulario'
import { useAuthStore } from '@/stores/auth'
import { useMetadataListasStore } from '@/stores/metadataListas'
import { ST } from '@/constants/ST'
import api from '@/services/api'
import FormularioCadastro from '@/components/base/formulario/FormularioCadastro.vue'
import CampoInput from '@/components/base/campos/CampoInput.vue'
import CampoSelect from '@/components/base/campos/CampoSelect.vue'
import CampoBusca from '@/components/base/campos/CampoBusca.vue'
import CampoBuscaLista from '@/components/base/campos/CampoBuscaLista.vue'
import AuditLogViewer from '@/components/base/auditoria/AuditLogViewer.vue'
import ModalFormularioV2 from '@/components/base/modal/ModalFormularioV2.vue'

const authStore = useAuthStore()
const metadataStore = useMetadataListasStore()

const props = defineProps({
  itemParaEditar: { type: Object, default: null },
  modeloVazio: {
    type: Object,
    default: () => ({
      idProdutoFornecedor: 0,
      idOrganizacao: null,
      idProduto: null,
      idFornecedor: null,
      codigoNoFornecedor: '',
      lstUnidadeFornecedor: '',
      qtdUnidadeFornecedor: 1,
      qtdUnidadeBase: 1,
      tempoFornecimento: null,
      quantidadeMinima: null,
      lstMoedaPadrao: '',
      lstModalidadeRateio: ''
    })
  }
})

const emit = defineEmits(['itemAtualizado', 'cancelar', 'show-notification', 'changesDetected'])

const mapaCampos = {
  idProduto: 'Produto Master',
  idFornecedor: 'Fornecedor',
  qtdUnidadeFornecedor: 'Quantidade Comprada',
  lstUnidadeFornecedor: 'Unidade do Fornecedor',
  qtdUnidadeBase: 'Quantidade Base'
}

const { item, isLoading: isSaving, isEditing, entityInfo, submitForm, handleCancel } = useFormulario(props, emit, { mapaCampos })

const mostrarAuditoria = ref(false)
const carregandoProduto = ref(false)

// Estado Descritivo de UI
const displayProduto = ref('')
const displayFornecedor = ref('')
const documentoFornecedor = ref('')
const idUnidadeBaseAtiva = ref('')

const simNaoOptions = [
  { id: true, label: 'Sim' },
  { id: false, label: 'Não' }
]

const listas = reactive({})

// GUARDIÃO: Flag para impedir salvamento se houver duplicidade
const duplicidadeDetectada = ref(false)

// GUARDIÃO: Verifica se já existe vínculo Produto+Fornecedor
const verificarDuplicidade = async () => {
  const idProduto = item.value.idProduto
  const idFornecedor = item.value.idFornecedor

  if (!idProduto || !idFornecedor || isEditing.value) {
    duplicidadeDetectada.value = false
    return false
  }

  try {
    await api.get(`/ProdutoFornecedores/rateio/${idProduto}/${idFornecedor}`)
    duplicidadeDetectada.value = true
    emit('show-notification', {
      message: 'Já existe um vínculo cadastrado para este Produto com este Fornecedor.',
      type: 'warning'
    })
    return true
  } catch (error) {
    duplicidadeDetectada.value = false
    return false
  }
}

const fornecedorSearch = computed(() => ({
  titulo: 'Pesquisar Fornecedor',
  endpointApi: 'Parceiros',
  idField: 'idParceiro',
  descField: 'nomeFantasia',
  camposFiltro: [
    { model: 'busca', label: 'Nome, Apelido ou Documento', tipo: 'text' }
  ],
  filtrosFixos: {
    isFornecedor: true,
    lstStatus: ST.Ativo,
    idEmpresa: authStore.empresaAtiva
  },
  colunasGrid: [
    { header: 'ID', dataField: 'idParceiro', width: '8%' },
    { header: 'Fantasia/Apelido', dataField: 'nomeFantasia', width: '40%' },
    { header: 'Razão Social', dataField: 'razaoSocial', width: '30%' },
    { header: 'Documento', dataField: 'documento', width: '22%' }
  ]
}))

const produtoSearch = computed(() => ({
  titulo: 'Pesquisar Produto',
  endpointApi: 'Produtos',
  endpointFetchPorCodigo: 'Produtos/por-sku',
  idField: 'idProduto',
  descField: 'nome',
  displayField: 'sku',
  tabela: 'TipoProduto',
  camposFiltro: [
    { model: 'busca', label: 'SKU ou Nome', tipo: 'text' },
    {
      model: 'lstNaturezaItem',
      label: 'Natureza',
      tipo: 'listabusca',
      tabela: 'TipoProduto'
    },
    {
      model: 'idTipoProduto',
      label: 'Tipo de Produto',
      tipo: 'select',
      optionsEndpoint: 'TiposProduto',
      optionsMapper: (item) => ({
        value: item.idTipoProduto,
        label: item.descricaoBreve || item.descricao || 'ID ' + item.idTipoProduto
      })
    }
  ],
  filtrosFixos: {
    lstStatus: ST.Ativo,
    compravel: true,
    idEmpresa: authStore.empresaAtiva
  },
  colunasGrid: [
    { header: 'SKU', dataField: 'sku', width: '18%' },
    { header: 'Produto', dataField: 'nome', width: '38%' },
    { header: 'Natureza', dataField: 'lstNaturezaItem', width: '14%' },
    { header: 'Tipo', dataField: 'nomeTipoProduto', width: '30%' }
  ]
}))

const onProdutoSelecionado = async (produtoObj) => {
  if (!produtoObj) {
    displayProduto.value = ''
    idUnidadeBaseAtiva.value = ''
    return
  }

  displayProduto.value = produtoObj.nome || produtoObj.sku
  item.value.lstNaturezaItem = produtoObj.lstNaturezaItem || ''
  item.value.idTipoProduto = produtoObj.idTipoProduto || null
  item.value.nomeTipoProduto = produtoObj.nomeTipoProduto || ''

  if (produtoObj.lstUnidadeMedidaBase) {
    idUnidadeBaseAtiva.value = produtoObj.lstUnidadeMedidaBase
  } else {
    try {
      carregandoProduto.value = true
      const res = await api.get(`/Produtos/${produtoObj.idProduto}`)
      idUnidadeBaseAtiva.value = res.data.lstUnidadeMedidaBase
    } catch (e) {
      console.warn('Não foi possível obter a Unidade Base do Produto', e)
    } finally {
      carregandoProduto.value = false
    }
  }

  item.value.idProduto = produtoObj.idProduto
  await verificarDuplicidade()
}

const onFornecedorSelecionado = async (parceiroObj) => {
  if (parceiroObj) {
    displayFornecedor.value = parceiroObj.nomeFantasia || parceiroObj.razaoSocial
    documentoFornecedor.value = parceiroObj.documento
  } else {
    displayFornecedor.value = ''
    documentoFornecedor.value = ''
  }

  item.value.idFornecedor = parceiroObj?.idParceiro || null
  await verificarDuplicidade()
}

onMounted(async () => {
  try {
    const result = await metadataStore.carregarListasParaTabelas(['ProdutoFornecedor', 'Produto', 'ProdutoFornecedorClausula'])
    Object.assign(listas, result)

    // Carrega lista ST para LstStatusClausula
    try {
      const resStatus = await api.get('/ListasCliente/lookup/ST')
      listas.statusClausula = resStatus.data
    } catch (error) {
      console.warn('Falha na lista status:', error)
      listas.statusClausula = []
    }

    if (isEditing.value && props.itemParaEditar) {
      displayProduto.value = props.itemParaEditar.nomeProduto || `Produto #${item.value.idProduto}`
      displayFornecedor.value = props.itemParaEditar.nomeFornecedor || `Fornecedor #${item.value.idFornecedor}`

      if (item.value.idProduto) {
        onProdutoSelecionado({ idProduto: item.value.idProduto, nome: props.itemParaEditar.nomeProduto })
      }
    }

    // Carrega cláusulas se já houver idProdutoFornecedor (edição)
    if (item.value.idProdutoFornecedor) {
      await carregarClausulasProduto()
    }
  } catch (error) {
    console.error('Erro crítico ao inicializar formulário de catálogo:', error)
  }
})

const salvarRelacao = async () => {
  if (duplicidadeDetectada.value) {
    emit('show-notification', {
      message: 'Já existe um vínculo cadastrado para este Produto com este Fornecedor. Corrija antes de salvar.',
      type: 'error'
    })
    return
  }

  const existe = await verificarDuplicidade()
  if (existe) return

  const payload = {
    ...item.value
  }

  await submitForm('ProdutoFornecedores', 'idProdutoFornecedor', payload)
}

// ============================================================
// CLAUSULAS DO PRODUTO
// ============================================================
const accordionState = reactive({
  clausulasProduto: false
})

const clausulasProduto = ref([])
const isLoadingClausulasProduto = ref(false)
const mostrarModalClausulaProduto = ref(false)
const clausulaProdutoEditando = ref(null)
const isSavingClausulaProduto = ref(false)
const formClausulaProduto = reactive({
  titulo: '',
  texto: '',
  ordemExibicao: null,
  isDefinitiva: false,
  isFixa: false,
  lstStatusClausula: '',
  lstAplicacaoClausula: '',
  lstVisibilidade: ''
})

const getTextoListaClausula = (idItem, listaRef) => {
  if (!idItem || !listaRef) return '-'
  const obj = listaRef.find(i => String(i.idListaClienteItem) === String(idItem) || String(i.idListaSistemaItem) === String(idItem))
  return obj ? (obj.textoLista || obj.descricaoBreve) : idItem
}

const carregarClausulasProduto = async () => {
  if (!item.value.idProdutoFornecedor) return
  isLoadingClausulasProduto.value = true
  try {
    const { data } = await api.get(`/ProdutoFornecedorClausulas?IdProdutoFornecedor=${item.value.idProdutoFornecedor}&PageSize=100`)
    clausulasProduto.value = data || []
  } catch (error) {
    const errData = error.response?.data
    let msg = 'Erro ao carregar cláusulas.'
    if (typeof errData === 'string') msg = errData
    else if (errData?.message) msg = errData.message
    else if (errData?.title) msg = errData.title
    else if (errData?.errors) msg = Object.values(errData.errors).flat().join('; ')
    emit('show-notification', { message: msg, type: 'error' })
  } finally {
    isLoadingClausulasProduto.value = false
  }
}

const abrirModalClausulaProduto = () => {
  clausulaProdutoEditando.value = null
  Object.assign(formClausulaProduto, {
    titulo: '',
    texto: '',
    ordemExibicao: null,
    isDefinitiva: false,
    isFixa: false,
    lstStatusClausula: '',
    lstAplicacaoClausula: '',
    lstVisibilidade: ''
  })
  mostrarModalClausulaProduto.value = true
}

const editarClausulaProduto = (row) => {
  clausulaProdutoEditando.value = row
  Object.assign(formClausulaProduto, {
    titulo: row.titulo,
    texto: row.texto,
    ordemExibicao: row.ordemExibicao,
    isDefinitiva: row.isDefinitiva,
    isFixa: row.isFixa,
    lstStatusClausula: row.lstStatusClausula,
    lstAplicacaoClausula: row.lstAplicacaoClausula,
    lstVisibilidade: row.lstVisibilidade
  })
  mostrarModalClausulaProduto.value = true
}

const salvarClausulaProduto = async () => {
  if (!formClausulaProduto.titulo || !formClausulaProduto.texto) {
    emit('show-notification', { message: 'Preencha o título e o texto da cláusula.', type: 'warning' })
    return
  }
  isSavingClausulaProduto.value = true
  try {
    if (clausulaProdutoEditando.value) {
      await api.put(`/ProdutoFornecedorClausulas/${clausulaProdutoEditando.value.idProdutoFornecedorClausula}`, {
        titulo: formClausulaProduto.titulo,
        texto: formClausulaProduto.texto,
        isDefinitiva: formClausulaProduto.isDefinitiva,
        isFixa: formClausulaProduto.isFixa,
        lstStatusClausula: formClausulaProduto.lstStatusClausula,
        lstAplicacaoClausula: formClausulaProduto.lstAplicacaoClausula || null,
        lstVisibilidade: formClausulaProduto.lstVisibilidade || null,
        xmin: clausulaProdutoEditando.value.xmin
      })
      emit('show-notification', { message: 'Cláusula atualizada.', type: 'success' })
    } else {
      await api.post('/ProdutoFornecedorClausulas', {
        idProdutoFornecedor: item.value.idProdutoFornecedor,
        titulo: formClausulaProduto.titulo,
        texto: formClausulaProduto.texto,
        isDefinitiva: formClausulaProduto.isDefinitiva,
        isFixa: formClausulaProduto.isFixa,
        lstAplicacaoClausula: formClausulaProduto.lstAplicacaoClausula || null,
        lstVisibilidade: formClausulaProduto.lstVisibilidade || null
      })
      emit('show-notification', { message: 'Cláusula criada.', type: 'success' })
    }
    mostrarModalClausulaProduto.value = false
    await carregarClausulasProduto()
  } catch (error) {
    const errData = error.response?.data
    let msg = 'Erro ao salvar cláusula.'
    if (typeof errData === 'string') msg = errData
    else if (errData?.message) msg = errData.message
    else if (errData?.title) msg = errData.title
    else if (errData?.errors) msg = Object.values(errData.errors).flat().join('; ')
    emit('show-notification', { message: msg, type: 'error' })
  } finally {
    isSavingClausulaProduto.value = false
  }
}

const toggleStatusClausulaProduto = async (row) => {
  const novoStatus = row.lstStatusClausula === 'ST1' ? 'ST2' : 'ST1'
  try {
    await api.patch(`/ProdutoFornecedorClausulas/${row.idProdutoFornecedorClausula}/status`, {
      lstStatusClausula: novoStatus
    })
    emit('show-notification', {
      message: `Cláusula ${novoStatus === 'ST1' ? 'ativada' : 'inativada'}.`,
      type: 'success'
    })
    await carregarClausulasProduto()
  } catch (error) {
    const errData = error.response?.data
    let msg = 'Erro ao alterar status.'
    if (typeof errData === 'string') msg = errData
    else if (errData?.message) msg = errData.message
    else if (errData?.title) msg = errData.title
    else if (errData?.errors) msg = Object.values(errData.errors).flat().join('; ')
    emit('show-notification', { message: msg, type: 'error' })
  }
}

const excluirClausulaProduto = async (row) => {
  try {
    await api.delete(`/ProdutoFornecedorClausulas/${row.idProdutoFornecedorClausula}`)
    emit('show-notification', { message: 'Cláusula excluída.', type: 'success' })
    await carregarClausulasProduto()
  } catch (error) {
    const errData = error.response?.data
    let msg = 'Erro ao excluir cláusula.'
    if (typeof errData === 'string') msg = errData
    else if (errData?.message) msg = errData.message
    else if (errData?.title) msg = errData.title
    else if (errData?.errors) msg = Object.values(errData.errors).flat().join('; ')
    emit('show-notification', { message: msg, type: 'error' })
  }
}

// Carregar cláusulas quando o produto for salvo
watch(() => item.value.idProdutoFornecedor, (id) => {
  if (id) carregarClausulasProduto()
})
</script>
